import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

/** Component Pages Here */
import HomePage from '../components/pages/public/HomePage';
import OtherPage from '../components/pages/OtherPage';
import ThankYou from '../components/pages/ThankYou';

import EventDetail from '../components/pages/public/EventDetail';
import RegistrationEvent from '../components/pages/public/RegistrationEvent';
import Signup from '../components/pages/public/Signup';
import LoginAdmin from '../components/pages/admin/LoginAdmin';
import DashboardAdmin from '../components/pages/admin/DashboardAdmin';
import EventForm from '../components/pages/admin/EventForm';
import TransactionPage from '../components/pages/admin/TransactionPage';

import DashboardClient from '../components/pages/client/DashboardClient';
import UserProfile from '../components/pages/client/UserProfile';
import LoginRegistration from '../components/pages/public/LoginRegistration';
import Page404 from '../components/pages/Page404';
import AccountProcess from '../components/pages/public/AccountProcess';

import helpers from '../helpers/helpers';

const Protected = ({ isLoggedIn, withPermission='',  children }) => {
    const user_permissions = helpers.getPermissions()

    if (!isLoggedIn) {
        return <Navigate replace to="/" />
    }
    else if(withPermission && !user_permissions.includes(withPermission)){
        return <Navigate replace to="/dashboard" />
    }
    return children;
};

function MainRoutes(){
    return (
        <Routes>
            <Route 
                exact path="/" 
                element={<HomePage />} 
            />

            <Route 
                exact path="e/:slug" 
                element={<EventDetail />} 
            />

            <Route 
                exact path="registration/event/:event_id" 
                element={<RegistrationEvent target_step="1" />} 
            />

            <Route 
                exact path="registration/event/:event_id/step-2" 
                element={<RegistrationEvent target_step="2" />} 
            />

            <Route 
                exact path="login" 
                element={
                    <Protected isLoggedIn={!helpers.isAuthenticated()}>
                        <LoginRegistration />
                    </Protected>
                }
            />

            {/* Request New Password */}
            <Route 
                exact path="recover-password" 
                element={
                    <Protected isLoggedIn={!helpers.isAuthenticated()}>
                        <AccountProcess request_type="recover-password" />
                    </Protected>
                }
            />

            {/* Password Reset */}
            <Route 
                exact path="reset-password/:token" 
                element={
                    <AccountProcess request_type="reset-password" />
                }
            />

            {/* Account Activation */}
            <Route 
                exact path="account-activation/:token" 
                element={
                    <AccountProcess request_type="activation" />
                }
            />

            {/* 
            ==========================================
            Admin Routes
            ==========================================
            */}

            <Route path="admin" 
                element={
                    <Navigate replace to="/admin/dashboard" />
                } 
            />

            <Route 
                exact path="admin/dashboard"
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()} withPermission="view-dashboard-events">
                        <DashboardAdmin />
                    </Protected>
                }
            />

            <Route 
                exact path="admin/manage/event/create" 
                // element={<EventForm />} 
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()}>
                        <EventForm />
                    </Protected>
                }
            />

            <Route 
                exact path="admin/manage/event/:event_id/details" 
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()}>
                        <EventForm />
                    </Protected>
                }
            />

            <Route 
                exact path="admin/manage/event/:event_id/transactions" 
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()}>
                        <TransactionPage />
                    </Protected>
                }
            />
            
            <Route 
                exact path="admin/staff-login"
                element={
                    <Protected isLoggedIn={!helpers.isAuthenticated()}>
                        <LoginAdmin />
                    </Protected>
                }
            />

            {/* 
            ==========================================
            Client/User Routes
            ==========================================
            */}

            <Route path="client" 
                element={
                    // {loggedIn ? <Navigate replace to="/admin/dashboard" /> : <Navigate replace to="/admin/staff-login" /> }
                    <Navigate replace to="/dashboard" />
                } 
            />

            <Route 
                exact path="dashboard" 
                //element={<DashboardClient />} 
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()}>
                        <DashboardClient />
                    </Protected>
                }
            />

            <Route 
                exact path="profile" 
                //element={<UserProfile />} 
                element={
                    <Protected isLoggedIn={helpers.isAuthenticated()}>
                        <UserProfile />
                    </Protected>
                }
            />

            {/* OTHER PAGE */}

            <Route 
                exact path="thankyou" 
                element={<ThankYou />} 
            />

            <Route 
                path="*" 
                element={<Page404 />} 
            />
        </Routes>
    )
}

export default MainRoutes;
